import { LegalPage } from "./legal/LegalPage";
import CSAEDocument from "./dynamic/CSAE";

export default function CSAEComponent() {
  return (
    <LegalPage path="/csae">
      <CSAEDocument />
    </LegalPage>
  );
}
